
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.813 10.138l-22.146 8.54c-1.511.607-1.502 1.45-.277 1.825l5.686 1.774 13.154-8.3c.622-.378 1.19-.175.723.24l-10.657 9.619h-.003l.003.001-.393 5.86c.575 0 .829-.263 1.15-.574l2.762-2.685 5.745 4.243c1.059.583 1.82.283 2.083-.98l3.77-17.772c.387-1.548-.59-2.248-1.6-1.791z","fill":"#E13131"}})])
          )
        }
      }
    